module.exports = __webpack_public_path__ + "static/404-Error-Page-MB_03-9916abf80da1bbe0b2f2c9f8b944aff8.jpg";